export const Footer = () => {
  return (
    <footer className="bg-[#111111] text-[#F4F4F0]" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-6 py-16 text-center">
        <p className="font-serif text-3xl font-light tracking-tight md:text-4xl">
          Joel Bruce
        </p>
        <p className="mt-4 text-sm text-[#999999]">
          City Councillor — District 3, Collins-Bayridge · Kingston, Ontario
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 border-t border-[#333333] pt-8 text-[10px] font-bold uppercase tracking-[0.25em] text-[#666666]">
          <span data-testid="footer-copyright">© 2026 Office of Councillor Joel Bruce</span>
          <span aria-hidden="true">·</span>
          <span data-testid="footer-domain">joelanthonybruce.ca</span>
        </div>
      </div>
    </footer>
  );
};
